export default function BusinessSettingsStep({
  settings,
  onChange,
  onBack,
  onFinish,
  loading,
  error,
}) {
  return (
    <form onSubmit={onFinish} className="space-y-5">
      {error && (
        <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          {error}
        </div>
      )}

      <SelectField
        label="Response Tone"
        name="tone"
        value={settings.tone}
        onChange={onChange}
        options={[
          "Friendly",
          "Professional",
          "Warm",
          "Short and direct",
          "Polished",
        ]}
      />

      <SelectField
        label="Response Length"
        name="responseLength"
        value={settings.responseLength}
        onChange={onChange}
        options={["Short", "Medium", "Detailed"]}
      />

      <Checkbox
        name="requireManualNegative"
        checked={settings.requireManualNegative}
        onChange={onChange}
        label="Require manual approval for negative reviews"
      />

      <Checkbox
        name="autoApprovePositive"
        checked={settings.autoApprovePositive}
        onChange={onChange}
        label="Allow auto-approval for positive reviews later"
      />

      <Checkbox
        name="includeSignature"
        checked={settings.includeSignature}
        onChange={onChange}
        label="Include a signature in suggested responses"
      />

      {settings.includeSignature && (
        <Field
          label="Signature Text"
          name="signatureText"
          placeholder="The RevUShield Team"
          value={settings.signatureText}
          onChange={onChange}
        />
      )}

      <div className="flex flex-col sm:flex-row gap-3 pt-2">
        <button
          type="button"
          onClick={onBack}
          className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-medium text-slate-700 hover:bg-slate-50 transition"
        >
          Back
        </button>

        <button
          type="submit"
          disabled={loading}
          className="w-full rounded-xl bg-indigo-600 px-4 py-3 text-sm font-medium text-white hover:bg-indigo-700 disabled:opacity-60 disabled:cursor-not-allowed transition"
        >
          {loading ? "Saving settings..." : "Finish Setup"}
        </button>
      </div>
    </form>
  );
}

function Field({ label, ...props }) {
  return (
    <label className="block">
      <span className="text-sm font-medium text-slate-700">{label}</span>

      <input
        {...props}
        className="mt-1.5 w-full rounded-xl border border-slate-200 bg-slate-50 px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition"
      />
    </label>
  );
}

function SelectField({ label, options, ...props }) {
  return (
    <label className="block">
      <span className="text-sm font-medium text-slate-700">{label}</span>

      <select
        {...props}
        className="mt-1.5 w-full rounded-xl border border-slate-200 bg-slate-50 px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition"
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </label>
  );
}

function Checkbox({ label, ...props }) {
  return (
    <label className="flex items-start gap-3 rounded-xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-700">
      <input
        type="checkbox"
        {...props}
        className="mt-0.5 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500"
      />
      <span>{label}</span>
    </label>
  );
}
